import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import Hero from '../components/Hero';

export default function NotFound() {
  return (
    <Box>
      <Hero title="Page Not Found" subtitle="The page you’re looking for may have been moved." bgImage="/assets/images/hero-404.svg" />
      <Container sx={{ py: 6 }}>
        <Button href="/" variant="contained">Back to Home</Button>
      </Container>
    </Box>
  );
}
